import { createFileRoute } from "@tanstack/react-router";
import ErrorPage from "../components/ErrorPage";

function FourOhFourErrorPage() {
  return <ErrorPage statusCode={404} />;
}

export const Route = createFileRoute("/404")({
  component: FourOhFourErrorPage,
});
